import React from 'react'
import { STEP_PROGRESS_HEADING_ID } from './stepProgress'

// Visually hidden h2 read via the step h1's aria-describedby after the step title.
const StepProgressHeading = ({ children }) => (
  <h2 id={STEP_PROGRESS_HEADING_ID} className="sr-only">
    {children}
  </h2>
)

export default StepProgressHeading
